module.exports = VeeValidate.Rules;